import React from 'react'

const SortableTableHeader = ({ name, value, onClick, className, sort = '' }) => {
  const byField = sort.split(',')[0]
  const order = sort.split(',')[1]
  const sortIndicatorClass = `fa fa-fw fa-sort${byField === name
    ? `-${order === 'asc' ? 'up' : 'down'}`
    : ''}`

  return (
    <th className={className} onClick={() => onClick(name)}>
      {value} <i className={sortIndicatorClass} />
    </th>
  )
}

export default SortableTableHeader
